import React, { Fragment, useCallback, useEffect, useState } from 'react'

import { v4 as uniqid } from 'uuid'

import SubmitForm  from '@/Form/V2/SubmitForm'
import Input       from '@/Form/V2/Input'

import getFormStatus from '@/Form/Functions/getFormStatus'

import Loader from '@Pure/Loader'

import FormsStore from '@Store/Forms'

const FORM_NAME = 'ServiceForm';

const FORM_INIT = { id: '', title: '', accounting_code: '', amount: '' };

const small_input_width = { width: 220 };

export default function ServiceForm (props)
{
	const [submit, setSubmit] = useState();
	const [submitting, setSubmitting] = useState(false);
	const [status, setStatus] = useState({ });

	useEffect(function ()
	{
		if (props.type === 'update') return;

		FormsStore.update(function (store)
		{
			store[FORM_NAME] = { ...FORM_INIT };
		});
	},
	[props.type]);

	const sendForm = useCallback(function (e)
	{
		if (submitting) return;

		setSubmitting(true);
		setSubmit(uniqid());
	},
	[submitting]);

	const onError = useCallback(function (update)
	{
		setSubmit(undefined);
		setStatus(update);
		setSubmitting(false);
	},
	[]);

	const onSuccess = useCallback(function (update)
	{
		setSubmit(undefined);
		setStatus(update);
		setSubmitting(false);

		if (props.type === 'update') return;

		FormsStore.update(function (store)
		{
			store[FORM_NAME] = { ...FORM_INIT };
		});
	},
	[props.type]);

	return (
		<Fragment>

			<div className="c-form c-form--service">

				<h2 className="c-title c-title--form">
					Service
				</h2>

				<div className="c-form__content-fields">

					<Input name="title" label="Titre"
						form={ FORM_NAME }
						bemit={ ['50%'] }
						error={ status.fields?.['title']?.error }
					/>

					<Input name="accounting_code" label="Code comptable"
						form={ FORM_NAME }
						style={ small_input_width }
						error={ status.fields?.['accounting_code']?.error }
					/>

					<Input name="amount" label="Montant par défaut (€)"
						form={ FORM_NAME }
						style={ small_input_width }
						error={ status.fields?.['amount']?.error }
						safe-number
					/>

				</div>

			</div>

			{
				submit ?
				(
					<SubmitForm form={ FORM_NAME } id={ submit }
						onError={ onError }
						onSuccess={ onSuccess }
						url={ '/services/' + (props.type || 'create') }
					/>
				)
				: undefined
			}

			{ getFormStatus(status) }

			<button type="button" className="c-btn c-btn--extra c-btn--green
				u-margin-top-30"
				onClick={ sendForm }>
				{
					props.type === 'update'
					? 'Mettre à jour'
					: 'Créer ce service'
				}
				{
					submitting ?
					(
						<Loader bemit={ ['bg-green', 'white'] }
							className="c-loader"
						/>
					)
					: undefined
				}
			</button>

		</Fragment>
	);
}